import { useContext, useMemo } from 'react';
import { TwoFactorRecoveryContext } from '../../contexts/twoFactorRecovery';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AlertWrapper } from './TwoFactorStyledComponents';
import { jsx as _jsx } from "react/jsx-runtime";
const errorTypes = {
  genericRecovery: ['danger', 'reAuth.recovery.error.errorText'],
  needsSupport: ['danger', 'reAuth.recovery.error.needsSupport'],
  tokenExpired: ['warning', 'reAuth.recovery.error.tokenExpired'],
  genericLoading: ['danger', 'reAuth.recovery.error.generic']
};
export const TwoFactorRecoveryAlerts = () => {
  const {
    isRecoveryEmailInErrorState,
    isTokenExpired,
    recoveryNeedsSupport,
    loadingError
  } = useContext(TwoFactorRecoveryContext);
  const type = useMemo(() => {
    if (isTokenExpired) return 'tokenExpired';
    if (recoveryNeedsSupport) return 'needsSupport';
    if (isRecoveryEmailInErrorState) return 'genericRecovery';
    if (loadingError) return 'genericLoading';
    return null;
  }, [recoveryNeedsSupport, isRecoveryEmailInErrorState, isTokenExpired, loadingError]);
  if (!type) return null;
  const [alertType, message] = errorTypes[type];
  return /*#__PURE__*/_jsx(AlertWrapper, {
    children: /*#__PURE__*/_jsx(UIAlert, {
      type: alertType,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      })
    })
  });
};